import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { SettingGroup } from '../../../models/setting-group';

import { AlertService } from '../../../services/common/alert.service';
import { SettingGroupService } from '../../../services/settings/setting-group.service';

@Component({
  selector: 'app-setting-group-form',
  templateUrl: './setting-group-form.component.html',
  styleUrls: ['./setting-group-form.component.css'],
})
export class SettingGroupFormComponent implements OnInit {
  formSubmitted: boolean = false;
  formSubmitting: boolean = false;

  @Input() setting_group_id: number | undefined;
  @Output() formEvent: EventEmitter<string> = new EventEmitter();

  settingGroup: SettingGroup = new SettingGroup();

  constructor(private alertService: AlertService, private settingGroupService: SettingGroupService) {}

  ngOnInit() {
    if (!this.setting_group_id) this.settingGroup = new SettingGroup();
    else this.settingGroupService.getSettingGroup(this.setting_group_id).then((response) => (this.settingGroup = response as SettingGroup));
  }

  fieldShowErrorMessage(field: any) {
    if (!field.valid && this.formSubmitted) return true;
    else return false;
  }

  fieldBuildErrorMessage(field: any, field_name: string): string {
    let error_message = [];
    let errors = field.errors || {};
    if (errors.required) error_message.push(field_name + ' is required');
    if (errors.notUnique) error_message.push(field_name + ' "' + field.value + '" is already taken');
    return error_message.join('<br />');
  }

  submitForm(formValid: any) {
    let scope: SettingGroupFormComponent = this;
    this.formSubmitted = true;
    if (formValid) {
      this.formSubmitting = true;
      if (this.settingGroup.id)
        this.settingGroupService
          .updateSettingGroup(this.settingGroup.id, this.settingGroup)
          .then((response) => {
            this.formSubmitting = false;
            if (response && response.text) {
              this.alertService.alert_status_success(response.text);
              this.formEvent.emit('Setting Group updated');
            } else {
              this.alertService.alert_status_danger('Error updating setting group');
            }
          })
          .catch(() => {
            scope.formSubmitting = false;
            scope.alertService.alert_status_danger('Error updating setting group');
          });
      else
        this.settingGroupService
          .createSettingGroup(this.settingGroup)
          .then((response) => {
            this.formSubmitting = false;
            if (response && response.text) {
              this.alertService.alert_status_success(response.text);
              this.formEvent.emit('Setting Group created');
            } else {
              this.alertService.alert_status_danger('Error creating setting group');
            }
          })
          .catch(() => {
            scope.formSubmitting = false;
            scope.alertService.alert_status_danger('Error creating setting group');
          });
    }
  }
}
